import { HttpApi, HttpApiClient, HttpApiEndpoint, HttpApiGroup, } from "@effect/platform";
import { Schema } from "effect";
/** CI stamps full lowercase Git SHA-1 commit identities. All other values are unknown. */
export function deploymentIdentity(value) {
    return typeof value === "string" && /^[0-9a-f]{40}$/.test(value)
        ? value
        : null;
}
export const DeploymentVersion = Schema.Struct({
    releaseId: Schema.NullOr(Schema.String),
});
export const deploymentApi = HttpApi.empty.add(HttpApiGroup.make("deployment").add(HttpApiEndpoint.get("version", "/v1/deployment/version").addSuccess(DeploymentVersion)));
/** Public metadata carries no session client or authentication transform. */
export const makeDeploymentClient = (baseUrl) => HttpApiClient.make(deploymentApi, { baseUrl });
//# sourceMappingURL=deployment.js.map